import { Table } from "@/components";
import type { PerformanceTabData } from "@/hooks/usePerformanceSectionData";
import { hooks } from "@/styles/breakpoints";
import * as styles from "./Tables.css";
import * as yoyStyles from "./YearOnYearTab.css";

const { useIsBelow } = hooks;

type Props = {
	data: PerformanceTabData["yearOnYear"];
	styleVariants?: yoyStyles.WrapVariants;
};

export default function YearOnYearTab({ data, styleVariants }: Props) {
	const isBelowL = useIsBelow("l");
	return (
		<div
			className={`${styles.wrap({ yoy: true })} ${yoyStyles.wrap(styleVariants)}`}
		>
			<Table
				data={data.data}
				headers={data.headers}
				className={styles.table}
				scroll={isBelowL}
			/>
		</div>
	);
}
